import styled from '@emotion/styled'
import { defineMessages, FormattedMessage } from '@faceup/localization'
import { Button, Typography } from '@faceup/ui-base'
import { useContext, useState } from 'react'
import FaceUpLogo from '../../assets/logo-fu.svg'
import { UserContext } from '../../Contexts/UserContext'
import welcomeImg from './assets/welcome.jpg'
import UserLogin from './UserLogin'

const { Title } = Typography

const messages = defineMessages('followUp.pages.authentication.landingPage', [
  { id: 'header', defaultMessage: 'Welcome to FaceUp' },
  {
    id: 'description',
    defaultMessage:
      'Now you can communicate with your organization securely and completely anonymously.',
  },
  { id: 'begin', defaultMessage: 'Start' },
] as const)

const Landing = () => {
  const {
    login: { hasAccount },
  } = useContext(UserContext)
  const [activeLogin, setActiveLogin] = useState(false)

  if (hasAccount || activeLogin) {
    return (
      <Wrapper>
        <UserLogin />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <TopWrapper>
        <img style={{ width: '7rem' }} src={FaceUpLogo} alt='FaceUp' />
        <CenterImage src={welcomeImg} />
        <Title level={2}>
          <FormattedMessage message={messages.header} />
        </Title>
        <Description>
          <FormattedMessage message={messages.description} />
        </Description>
      </TopWrapper>
      <Button block type='primary' onClick={() => setActiveLogin(true)}>
        <FormattedMessage message={messages.begin} />
      </Button>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-flow: nowrap column;
  justify-content: space-between;
  height: 100vh;
  max-width: 600px;
  width: 100%;
  margin: auto;
  padding: calc(20px + var(--safe-area-inset-top)) 20px calc(20px + var(--safe-area-inset-bottom));
`

const CenterImage = styled.img`
  margin: 50px 0 32px;
  width: 100%;
`

const TopWrapper = styled.div`
  text-align: center;
  padding-top: 20px;
  width: 100%;
`

const Description = styled.div`
  font-size: 16px;
  margin-top: 14px;
`

export default Landing
